module.exports = __webpack_public_path__ + "assets/img/flag-task-createContent.ce793028.svg";